<template>
  <table class="child-table">
    <thead>
      <tr>
        <th
          v-for="(header, headerIdx) in headers"
          :key="headerIdx"
          :style="{ 'text-align': headerIdx === 2 ? 'end' : 'left' }"
        >
          <span class="header-text">{{ header }}</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="width: 40%">
          <BaseSmallInput placeholder="Nhập mã đơn" v-model="searchParams.code_contains" @change="onSearch" />
        </td>
        <td style="width: 40%">
          <BaseSmallInput
            placeholder="Nhập tên, mô tả"
            v-model="searchParams.description_contains"
            @change="onSearch"
          />
        </td>
        <td style="text-align: end; width: 20%" class="error--text">
          {{ items.length ? get(expectQuantity, 'totalQuantity', '-') : '' }}
        </td>
      </tr>
      <tr v-for="(item, itemIdx) in items" :key="itemIdx">
        <td class="primary--text">{{ get(item, 'code', '-') }}</td>
        <td>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs" class="trundle-text">{{ get(item, 'description', '-') }}</div>
            </template>
            <span class="white--text text-justify">
              {{ get(item, 'description', '') }}
            </span>
          </v-tooltip>
        </td>
        <td style="text-align: end">{{ formatNumber(item.quantity) }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { get } from 'lodash'
import { mapState } from 'vuex'
import BaseSmallInput from '../../../components/basic/BaseSmallInput.vue'
export default {
  components: {
    BaseSmallInput
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState('importDeliveries', ['expectQuantity'])
  },
  data() {
    return {
      headers: ['Model', 'Mô tả', 'SL nhập'],
      searchParams: {
        code_contains: '',
        description_contains: ''
      },
      get
    }
  },
  methods: {
    onSearch() {
      this.$emit('onSearch', this.searchParams)
    },
    formatNumber(number) {
      return !isNaN(Number(number)) ? Number(number).toLocaleString('en-US') : '--'
    }
  }
}
</script>

<style lang="scss" scoped>
.child-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.child-table th,
.child-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.child-table td {
  height: 55px;
}

.child-table th {
  background-color: #c0d8ff;
  height: 70px;
}

tbody {
  background-color: white;
}

.header-text {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}

.trundle-text {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
